import FeatureCard from '../../components/FeatureCard/FeatureCard';
import featuresData from './featuresData';

const Features = () => {
  return (
    <section className="relative py-24 px-4 scroll-mt-24 bg-white">
      <div className="relative z-10 max-w-6xl mx-auto">
        <div className="text-center mb-4">
          <span className="inline-block text-[#6B8F8A] text-sm font-semibold tracking-widest uppercase mb-3">
            Our Platform
          </span>
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-[#3a3a3a] text-center mb-4">
          Explore Our Technology
        </h2>
        <p className="text-[#6b7280] text-center text-lg max-w-2xl mx-auto mb-16 leading-relaxed">
          Built with industry-leading integrations to deliver the best animal welfare platform in the world.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuresData.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
